var _a, _b, _c, _d;
import { IdSoundState } from "../../constants/IdSoundState";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { IdSoundGroup } from "../../utils/sound/IdSoundGroup";
import { IdIcon } from "../generic/icon/IdIcon";
export var mapHudButtonsSoundDisplayProps = new Map([
    [
        IdSoundGroup.Music,
        {
            icons: (_a = {},
                _a[IdSoundState.Enabled] = IdIcon.OptionsMusicOnIcn,
                _a[IdSoundState.Disabled] = IdIcon.OptionsMusicOffIcn,
                _a),
            locas: (_b = {},
                _b[IdSoundState.Enabled] = IdLoca.tooltip_toggleMusicOn_web,
                _b[IdSoundState.Disabled] = IdLoca.tooltip_toggleMusicOff_web,
                _b),
        },
    ],
    [
        IdSoundGroup.Sound,
        {
            icons: (_c = {},
                _c[IdSoundState.Enabled] = IdIcon.OptionsSoundOnIcn,
                _c[IdSoundState.Disabled] = IdIcon.OptionsSoundOffIcn,
                _c),
            locas: (_d = {},
                _d[IdSoundState.Enabled] = IdLoca.tooltip_toggleSoundOn_web,
                _d[IdSoundState.Disabled] = IdLoca.tooltip_toggleSoundOff_web,
                _d),
        },
    ],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/mapHudButtonsSoundDisplayProps.ts
// module id = 2319
// module chunks = 3